"use strict";

exports.__esModule = true;
exports.default = void 0;
/**
 * Get attributed string start value
 *
 * @param  {Object}  attributed string
 * @return {number} start
 */

var start = function start(attributedString) {
  var runs = attributedString.runs;
  return runs.length === 0 ? 0 : runs[0].start;
};

var _default = start;
exports.default = _default;